import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { Button, DialogActions, DialogContent, DialogTitle, Tooltip } from '@material-ui/core';
import { DropzoneArea } from 'material-ui-dropzone';
import DownloadableFile from '../../assets/crm_upload_template.xlsx';
import GetAppIcon from '@material-ui/icons/GetApp';


function Dropzone(props) {
    const { open, onChange, onClose, preview, disabled } = props

    return (
        <Dialog open={open} onClose={onClose} maxWidth={"lg"}>
            <DialogTitle id="form-dialog-title">
                Upload file
                <IconButton aria-label="close" onClick={onClose} style={{ position: 'absolute', top: '5px', right: '20px' }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DropzoneArea
                    acceptedFiles={['.xls', '.xlsx']}
                    showPreviews={true}
                    showPreviewsInDropzone={false}
                    useChipsForPreview
                    onChange={(e) => onChange(e)}
                />
            </DialogContent>
            <DialogActions>
                {props.fileDownload ?
                <a style={{textDecoration:'none'}} href={DownloadableFile} target='_blank' rel="noopener noreferrer" download='crm_upload_template.xlsx'>
                    <Tooltip title="Download template">
                    <IconButton size='small'><GetAppIcon/></IconButton>
                    </Tooltip>
                </a>: null}
                <Button onClick={onClose} color="secondary" variant='contained' size='small'>Cancel</Button>
                <Button color="primary" variant='contained' size='small' disabled={disabled} onClick={preview}>Preview</Button>
            </DialogActions>
        </Dialog>
    )
}

export default Dropzone;